import React, { Component } from 'react';

import DefaultLayout from '../containers/Layouts/DefaultLayout';
import GenericError from '../containers/Errors/GenericError';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  render() {
    const { hasError } = this.state;
    if (hasError) {
      // You can render any custom fallback UI
      return (
        <div className="page-app">
          <DefaultLayout component={GenericError} />
        </div>
      );
    }

    const { children } = this.props;

    return children;
  }
}
export default ErrorBoundary;
